import { render, staticRenderFns } from "./AsociadosView.vue?vue&type=template&id=5008119c&scoped=true&"
import script from "./AsociadosView.vue?vue&type=script&lang=js&"
export * from "./AsociadosView.vue?vue&type=script&lang=js&"
import style0 from "./AsociadosView.vue?vue&type=style&index=0&id=5008119c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008119c",
  null
  
)

export default component.exports